<template>
    <div class="modal fade legal-modal" :id="id" tabindex="-1" role="dialog" aria-hidden="false">
        <div class="modal-dialog modal-fixed" role="document">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <h5 class="modal-title" v-html="title"></h5>

                    <button type="button" class="close" @click="close" aria-label="Close">
                        <span aria-hidden="true"><img src="img/ui-elements/close-img.png" alt="Close" /></span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LegalModal",
        props: {
            id: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            scrollTo: {
                type: String,
                required: false
            }
        },
        mounted: function() {
            if (this.scrollTo) {
                this.scrollToElement(this.scrollTo);
            }
        },
        methods: {
            openFromModal: function(open, close) {
                this.$emit('open', { open: open, close: close });
            },
            close: function() {
                this.$emit('close', this.id);
            },
            scrollToElement: function(targetId) {
                const scrollTarget = document.getElementById(targetId);
                if (scrollTarget) {
                    scrollTarget.parentElement.scroll(0, scrollTarget.offsetTop);
                }
            }
        }
    }
</script>

<style scoped>

    .legal-modal {
        animation: none;
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
        opacity: 1;
    }

    .button-span {
        padding: 0 8px;
    }

    .footer-references {
        color: inherit;
        bottom: unset;
    }

    .centered {
        text-align: center;
    }

    .underline {
        text-decoration: underline;
    }

    em.strong,
    h6.section {
        font-weight: bold !important;
    }

    table {
        font-size: 0.9em;
        line-height: 1.1em;
        border-collapse: separate;
        border-spacing: 5px;
        margin-bottom: 2em;
    }
    th, td {
        padding: 5px;
    }
    tr.head {
        padding-bottom: 5px;
        border-bottom: 1px solid #00bcff;
    }
    td {
        background-color: #efefef;
    }
    td.padded {
        width: 15%;
    }

    .cookie-toggles .on.active {
        color: #89d329;
    }
    .cookie-toggles .off.active {
        color: red;
    }

</style>